/* Adds "and shipping is free" to the Glacier Duo upsell in the cart drawer
   when upgrading to the Duo takes the cart over the free-shipping threshold. */
(function () {
  var T = window.GlacierTheme || {};
  var goal = +T.freeShipping || 0;
  if (!goal || !T.duo) return;
  var box = document.querySelector('#CartDrawer [data-duo-upsell]');
  if (!box) return;
  var busy = false;
  function update() {
    if (busy || box.hidden) return;
    var span = box.querySelector('.drawer__upsell-body > span:last-child');
    if (!span || span.dataset.freeShip) return;
    busy = true;
    fetch((T.routes && T.routes.cart) || '/cart.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        var single = null;
        cart.items.forEach(function (i) { if (!single && T.duo.items.indexOf(i.product_id) > -1) single = i; });
        if (!single) return;
        var extra = T.duo.price - single.final_price;
        if (cart.total_price < goal && cart.total_price + extra >= goal) {
          span.textContent = span.textContent.replace(/\.\s*$/, '') + ', and shipping is free.';
          span.dataset.freeShip = '1';
        }
      })
      .catch(function () {})
      .then(function () { busy = false; });
  }
  new MutationObserver(update).observe(box, { childList: true, subtree: true, attributes: true, attributeFilter: ['hidden'] });
  update();
})();
